/**
 * Body の入力種別
 */
export type BodyType = 'number' | 'date' | 'list' | 'text';

/**
 * attr_type と multiple_select から Body の入力種別を算出する共通関数
 * - 3,4 => number
 * - 5   => date
 * - 11,12,13 かつ multiple_select => list
 * - それ以外 => text
 */
export function computeBodyType(attrType: any, multipleSelect: any): BodyType {
  const t = Number(attrType);
  const isMulti = multipleSelect === true || Number(multipleSelect) === 1;
  if (t === 3 || t === 4) return 'number';
  if (t === 5) return 'date';
  if ((t === 11 || t === 12 || t === 13) && isMulti) return 'list';
  return 'text';
}